module.exports = __webpack_public_path__ + "static/media/c466d84e-5118-4a73-a944-e2170d63504e.01ac07dd.png";